import { useQuery } from '@tanstack/react-query';

import { dashboardService } from '@/services/rest/index';
import type { QueryParams } from '@/types/common/api.type';
import { dashboardQueryKeys } from './queryKeys';

export const useKeyMetrics = (params?: QueryParams) =>
    useQuery({
        queryKey: dashboardQueryKeys.custom('keyMetrics'),
        queryFn: () => dashboardService().getKeyMetrics(params),
        placeholderData: previousData => previousData,
    });

export const useTaskRepeat = (params?: QueryParams) =>
    useQuery({
        queryKey: dashboardQueryKeys.custom('taskRepeat', params ?? {}),
        queryFn: () => dashboardService().getTaskRepeat(params),
        placeholderData: previousData => previousData,
    });

export const useViolationCustomer = (params?: QueryParams) =>
    useQuery({
        queryKey: dashboardQueryKeys.custom('violationCustomer', params ?? {}),
        queryFn: () => dashboardService().getViolationCustomer(params),
        placeholderData: previousData => previousData,
    });

export const usePartSuggestion = (params?: QueryParams) =>
    useQuery({
        queryKey: dashboardQueryKeys.custom('partSuggestion', params ?? {}),
        queryFn: () => dashboardService().getPartSuggestion(params),
        placeholderData: previousData => previousData,
    });

export const useTechnicalTaskRepeat = (params?: QueryParams) =>
    useQuery({
        queryKey: dashboardQueryKeys.custom(
            'technicalTaskRepeat',
            params ?? {}
        ),
        queryFn: () => dashboardService().getTechnicalTaskRepeat(params),
        placeholderData: previousData => previousData,
    });

export const useTechnicalPerformance = (params?: QueryParams) =>
    useQuery({
        queryKey: dashboardQueryKeys.custom(
            'technicalPerformance',
            params ?? {}
        ),
        queryFn: () => dashboardService().getTechnicalPerformance(params),
        placeholderData: previousData => previousData,
    });

export const useAverageRating = (params?: QueryParams) =>
    useQuery({
        queryKey: dashboardQueryKeys.custom('averageRating', params ?? {}),
        queryFn: () => dashboardService().getAverageRating(params),
        placeholderData: previousData => previousData,
    });

export const useTaskRepeatMetric = (params?: QueryParams) =>
    useQuery({
        queryKey: dashboardQueryKeys.custom('taskRepeatMetric'),
        queryFn: () => dashboardService().getTaskRepeatMetric(params),
        placeholderData: previousData => previousData,
    });

export const useProcessingMetric = (params?: QueryParams) =>
    useQuery({
        queryKey: dashboardQueryKeys.custom('processingMetric'),
        queryFn: () => dashboardService().getProcessingMetric(params),
        placeholderData: previousData => previousData,
    });

export const useProcessingSummary = (params?: QueryParams) =>
    useQuery({
        queryKey: dashboardQueryKeys.custom('processingSummary', params ?? {}),
        queryFn: () => dashboardService().getProcessingSummary(params),
        placeholderData: previousData => previousData,
    });

export const useOperationSummary = (params?: QueryParams) =>
    useQuery({
        queryKey: dashboardQueryKeys.custom('operationSummary', params ?? {}),
        queryFn: () => dashboardService().getOperationSummary(params),
        placeholderData: previousData => previousData,
    });

export const useTicketSummaryByCustomer = (params?: QueryParams) =>
    useQuery({
        queryKey: dashboardQueryKeys.custom(
            'ticketSummaryByCustomer',
            params ?? {}
        ),
        queryFn: () => dashboardService().getTicketSummaryByCustomer(params),
        placeholderData: previousData => previousData,
    });

export const useTaskRepeatSummaryByDate = (params?: QueryParams) =>
    useQuery({
        queryKey: dashboardQueryKeys.custom(
            'taskRepeatSummaryByDate',
            params ?? {}
        ),
        queryFn: () => dashboardService().getTaskRepeatSummaryByDate(params),
        placeholderData: previousData => previousData,
    });

export const usePartSuggestionMetric = (params?: QueryParams) =>
    useQuery({
        queryKey: dashboardQueryKeys.custom('partSuggestionMetric'),
        queryFn: () => dashboardService().getPartSuggestionMetric(params),
        placeholderData: previousData => previousData,
    });

export const usePartSuggestionSummaryByCustomer = (params?: QueryParams) =>
    useQuery({
        queryKey: dashboardQueryKeys.custom(
            'partSuggestionSummaryByCustomer',
            params ?? {}
        ),
        queryFn: () =>
            dashboardService().getPartSuggestionSummaryByCustomer(params),
        placeholderData: previousData => previousData,
    });

export const useOperationPerformance = (params?: QueryParams) =>
    useQuery({
        queryKey: dashboardQueryKeys.custom(
            'operationPerformance',
            params ?? {}
        ),
        queryFn: () => dashboardService().getOperationPerformance(params),
        placeholderData: previousData => previousData,
    });
